import React, { Fragment } from 'react'
import actions from 'redux/actions'
import { useMemo, useCallback, useMedia } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants, getMainPageLink } from 'common/helpers'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import { Overlay } from 'components/_new/layout'
import Title from 'components/_new/typography/deprecated/Title/Title'
import { Button } from 'components/_new/controls'

import s from './OfferTest25offSuccessModal.scss'
import messages from './messages'

import birdSuccess from './images/birdSuccess.svg'


const close = () => actions.models.modals.close(constants.modals.cancelSubscription.offerTest25offSuccess)

const OfferTest25offSuccessModal = () => {
  const mainPageLink = useConnect((state) => getMainPageLink({ state }))

  const { isMobile } = useMedia()

  const handleClick = useCallback(() => {
    actions.models.router.push(mainPageLink)
    close()
  }, [ mainPageLink ])

  const footerNode = useMemo(() => (
    <Fragment>
      {
        isMobile && (
          <img className={s.bird} src={birdSuccess} alt="" />
        )
      }
      <Button
        className={s.button}
        size="md"
        color="brand"
        title={messages.ok}
        onClick={handleClick}
      />
    </Fragment>
  ), [ isMobile, handleClick ])

  return (
    <Fragment>
      <ModalContainer>
        <Overlay onClick={close} />
        <Modal onClose={close} footerNode={footerNode}>
          {
            !isMobile && (
              <img className={s.bird} src={birdSuccess} alt="" />
            )
          }
          <Title message={messages.title} size="lg" html />
        </Modal>
      </ModalContainer>
    </Fragment>
  )
}


export default OfferTest25offSuccessModal
